import { render, staticRenderFns } from "./GruposList.vue?vue&type=template&id=d31882a6&scoped=true&"
import script from "./GruposList.vue?vue&type=script&lang=js&"
export * from "./GruposList.vue?vue&type=script&lang=js&"
import style0 from "./GruposList.vue?vue&type=style&index=0&id=d31882a6&prod&lang=scss&scoped=true&"
import style1 from "./GruposList.vue?vue&type=style&index=1&id=d31882a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31882a6",
  null
  
)

export default component.exports